var map = {
	"./ant-design.svg": 9057,
	"./bootstrap.png": 8317,
	"./css.svg": 8776,
	"./expressjs.svg": 1644,
	"./firebase.png": 7756,
	"./github.svg": 2566,
	"./heroku.svg": 8603,
	"./html5.svg": 1077,
	"./jest.png": 8701,
	"./js.png": 2442,
	"./ld.png": 2815,
	"./mongodb.svg": 467,
	"./nextjs.png": 5101,
	"./node.svg": 3247,
	"./npm.svg": 7278,
	"./nx.png": 7565,
	"./postql.png": 9802,
	"./react.png": 2450,
	"./reactflow.png": 2814,
	"./redux.png": 9105,
	"./sass.png": 2445,
	"./shadcn.png": 614,
	"./typescript.png": 6078,
	"./vite.jpeg": 2938,
	"./vue.png": 3279,
	"./zendesk.png": 4975
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3759;